export default __webpack_public_path__ + "static/media/Mark-5-3D-Model-00.e2e25bcb.jpg";